import {Component, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {NavbarComponent} from "../../components/navbar/navbar.component";
import {FormsModule} from "@angular/forms";
import {ApplyJobDto} from "../../contracts/apply-jobs/apply-job.dto";
import {FileInput} from "../../components/file-input/file-input";
import {ApplyJobService} from "../../services/applyJobs/apply-job.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-apply-job',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NavbarComponent,
    FormsModule,
    FileInput],
  templateUrl: './apply-job.html'
})
export class ApplyJob implements OnInit {
  model: ApplyJobDto = new ApplyJobDto();
  saving: boolean;
  error: string;
  success: string;
  submitted: boolean;

  constructor(private applyJobService: ApplyJobService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    const event = this.route.snapshot.queryParams['event'];
    if (event) {
      this.model.event = event;
    }
  }

  onFileChange($event: File[]) {
    if ($event.length === 0) return;
    this.model.cvUpload = $event[0];
  }

  isValid() {
    if (!this.model.consent) return false;
    return true;
  }

  async submit() {
    if (this.submitted) return;
    if (this.saving) return;
    this.saving = true;
    try {
      await this.applyJobService.submit(this.model);
      this.success = 'Your application has been submitted successfully.';
      this.submitted = true;
    } catch (err) {
      this.error = err.toString();
    }
    this.saving = false;
  }

}
